import { LoadingSpinner } from "@/modules/ui/components/loading"
import { BoxProgrammationImportProgramLayout } from "@modules/boxB2BProgram/components/boxProgrammationImportProgramLayout"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { ErrorBoundary } from "react-error-boundary"
import { ErrorView } from "@/components/ui/layout/error/errorView"
import { Suspense } from "react"

export const useProgrammationSessionImportSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToImportProgramSelection = (boxProgramId: string, startDate: Date, endDate: Date) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxProgrammationImportProgramLayout boxProgramId={boxProgramId} startDate={startDate} endDate={endDate} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
    })
  }

  return { navigateToImportProgramSelection }
}
